export default {
  metadata: {
    version: '1.0.0',
    id: 'footer-icon-link-1.0.0',
    name: 'JDSFooterIconLinks',
    platform: 'web'
  },
  hierarchy: {
    container: [
      'title-jds-text',
      {
        'icons-container': ['jds_button']
      }
    ]
  },
  base: {
    container: {
      gap: '{f_0}',
      'flex-direction': '{f_1}',
      'align-items': '{f_2}'
    },
    jds_button: {
      size: 'small'
    },
    'icons-container': {
      'flex-direction': '{f_3}',
      gap: '{f_4}'
    },
    'title-jds-text': {
      'font-family': '{text_91}',
      color: '{text_20}',
      'font-size': '{text_90}',
      'line-height': '{text_92}',
      'letter-spacing': '{text_93}',
      'font-weight': '{text_94}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      language: 'en'
    }
  },
  api: {
    data: {
      'icons-container': {
        value: {
          name: 'links',
          type: 'list',
          object: {
            icon: 'string',
            href: 'string'
          }
        }
      },
      jds_button: {
        icon: {
          name: 'links.icon',
          type: 'string'
        }
      },
      'title-jds-text': {
        value: {
          type: 'string',
          name: 'title'
        }
      }
    },
    a11y: {
      'icons-container': {
        name: 'links',
        repeating: {
          ariaLabel: 'iconAriaLabel',
          ariaDescribedby: {
            name: 'iconAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_button: {
        properties: {
          ariaLabel: 'links.iconAriaLabel',
          ariaDescribedby: 'links.iconAriaDescribedby'
        }
      }
    }
  }
};
